module.exports = "<div class=\"tenantError\">\r\n    <div class=\"tenant_Box\">\r\n        <div class=\"tenant_img\"></div>\r\n        <div class=\"tenant_msg\"><img alt=\"\" data-bind=\"attr:{src:urlAddPrefix('/public/images/tenant1.png')}\" />\r\n            <div class=\"tenant_msg_tips\">租户未开通或域名错误！</div>\r\n        </div>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/tenantError/index.html
// module id = 237
// module chunks = 0